import { render, staticRenderFns } from "./LevelReadingLegend.vue?vue&type=template&id=3c689371&scoped=true&"
import script from "./LevelReadingLegend.vue?vue&type=script&lang=js&"
export * from "./LevelReadingLegend.vue?vue&type=script&lang=js&"
import style0 from "./LevelReadingLegend.vue?vue&type=style&index=0&id=3c689371&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c689371",
  null
  
)

export default component.exports